export const paths = {}
